import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthService } from "../services/authentication.service";
import { Utils } from "../resources/utils";
import { environment } from "src/environments/environment";
import { StorageService } from "../services/storage.service";
import { version } from 'package.json';
@Injectable({
  providedIn: "root",
})
export class AppInterceptorService implements HttpInterceptor {
  whiteList = ["cargo/request/update", "cargo/update/set"];
  private readonly skipAuthRedirectUrls = ["accounting/SIIGO"];
  /**
   * Cargas multipart en las que el navegador debe generar el Content-Type con
   * su boundary. No se les fija la cabecera ni se les toca el body: un FormData
   * que pase por removeEmpty queda vacío.
   */
  private readonly multipartUrls = ["accial/vouchers/sync-xlsx"];
  constructor(private router: Router, private authService: AuthService, private utils: Utils) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = StorageService.checkStorage().getItem("_token") || "T3cl0g1";
    let companyId = '9013312320';
    let appType = '3bba218d9b555c1777e1c9cb45c1b90f';
    if (req && req.url.includes('email/formContact') && this.authService && this.authService.getUserSession().clientCompanyId !== environment.rootNit) appType = 'KU62iVo2ytWCaedjWat1';
    if (StorageService.checkStorage().getItem('_companyId')) companyId = StorageService.checkStorage().getItem('_companyId');
    else if (req && req.headers && req.headers.get('companyId')) companyId = req.headers.get('companyId');
    else companyId = this.authService && this.authService.getCompanySaaS() ? this.authService.getCompanySaaS().companyId : "9013312320";
    let request = req;
    if (token) {
      let headers = new HttpHeaders();
      headers = headers.set("appType", appType);
      headers = headers.set("companyId", companyId);
      headers = headers.set(
        "userSession",
        StorageService.checkStorage().getItem("_email") || StorageService.checkStorage().getItem("_email") || "Invited"
      );
      headers = headers.set("tokenUser", token);
      headers = headers.set("version", version);
      if (req.headers.has("productId")) {
        headers = headers.set("productId", req.headers.get("productId"));
      }
      if (req.headers.has("clientId")) {
        headers = headers.set("clientId", req.headers.get("clientId"));
      }
      if (req && req.url && this.multipartUrls.some(url => req.url.includes(url))) {
        request = req.clone({
          headers,
          body: req.body,
        });
      } else if (
        req &&
        req.url &&
        (req.url.includes("guide/uploadSimpleGuides") ||
          req.url.includes("guide/uploadGuides") ||
          req.url.includes("guide/generate?type=") ||
          req.url.includes("cargo/reports?&excel=true") ||
          req.url.includes("route/cargo/upload") ||
          req.url.includes("guide/excelToGuide") ||
          req.url.includes("cargo/cargoMultiple") ||
          req.url.includes("cargo/rndc/bill") ||
          req.url.includes("catalog/logs")) ||
        req.url.includes("drivin/order/excel")
      ) {
        headers = headers.set("Content-Type", "multipart/form-data");
        request = req.clone({
          headers,
          body: req.body ? req.body : null,
        });
      } else if (req && req.url && this.whiteList.some(url => req.url.includes(url))) {
        headers = headers.set("Content-Type", "application/json");
        request = req.clone({
          headers,
          body: req.body ? req.body : null,
        });
      } else {
        headers = headers.set("Content-Type", "application/json");
        request = req.clone({
          headers,
          body: req.body ? this.utils.removeEmpty(req.body) : null,
        });
      }
    }

    return next.handle(request).pipe(
      finalize(() => { }),
      catchError((err: HttpErrorResponse) => {
        const skipAuthRedirect = this.shouldSkipAuthRedirect(req);
        if (err && err.status && req.params.get("token")) this.router.navigateByUrl("/home");
        else if (err.status === 401 && !skipAuthRedirect) this.router.navigateByUrl("/account/login");
        return throwError(err);
      })
    );
  }

  private shouldSkipAuthRedirect(req: HttpRequest<any>): boolean {
    return !!(req && req.url && this.skipAuthRedirectUrls.some(url => req.url.includes(url)));
  }
}
